// extracted by mini-css-extract-plugin
export default {"card":"Dba-z","carousel":"Eba-z"};